// import consts from "@/consts"
import {getApiProps} from "@/lib/lib";
// import {arraySplitIntoChunks} from "@/lib/lib";

// Built on every call and never cached: the array is also changed in place (splice on delete,
// push on a single update, sort in a getter) and nothing tells a cached map that it has gone stale.
function getVideoRecordsIndexMap(state) {
    return new Map(state.videoRecords.map((r, i) => [r.xid, i]))
}

export default {
    state: {
        videoRecords_index: [],
        videoRecords: [],
    },
    actions: {
        fetchVideoRecords4Date({commit, dispatch, getters}, args) {
            return new Promise((resolve, reject) => {
                args = {unitId: '', date: '', ...args}
                if (args.date == 'today' || !args.date) args.date = getters.getDateToday
                let isToday = (args.date == getters.getDateToday)
                if (!getters.getApiToken || !args.unitId || !args.date) {
                    return reject(false)
                }
                if (args.unitId > 0 && !args.force) {
                    let index = getters.getTripsIndex.find(i => (i.unitId == args.unitId && i.date == args.date))
                    if (index) {
                        return resolve(true)
                    }
                }

                dispatch('setLastCall', {name: 'fetchVideoRecords4Date', args, time: Date.now() / 1000})
                if (isToday) {
                    dispatch('setLastCall', {name: 'fetchLastVideoRecords', args, time: Date.now() / 1000})
                }

                let params = getApiProps('video_records', {withAddress: 1, ...args})
                delete params.unitId;delete params.date;
                this.$api.videoRecords.get4Date(args.unitId, args.date, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('storeVideoRecords', response.data)
                            const count = response.data.length
                            if (count) commit('setVideoRecordsIndex', {...args, count})
                            resolve(true)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchVideoRecords4Date', args, inprogress: false})
                        if (isToday) {
                            dispatch('setLastCall', {name: 'fetchLastVideoRecords', args, inprogress: false})
                        }
                    });
            })
        },
        fetchVideoRecords4Period({dispatch, commit, getters}, args) {
            return new Promise((resolve, reject) => {
                let isToday = (args.date == getters.getDateToday)
                if (!getters.getApiToken || !args.unitId || !args.from || !args.to) {
                    return reject(false)
                }

                // if (args.unitId > 0 && !args.force) {
                //     let index = getters.getVideoRecordsIndex.find(i => (i.unitId == args.unitId && i.date == args.date))
                //     if (index) {
                //         return resolve(true)
                //     }
                // }

                dispatch('setLastCall', {name: 'fetchVideoRecords4Date', args, time: Date.now() / 1000})
                /* getters.getTimeToday+24h and args.from/to intersect*/
                if (isToday) {
                    dispatch('setLastCall', {name: 'fetchLastVideoRecords', args, time: Date.now() / 1000})
                }

                let params = getApiProps('video_records', {withAddress: 1, ...args})
                delete params.unitId;delete params.from;delete params.to;
                this.$api.videoRecords.get4Period(args.unitId, args.from, args.to, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('storeVideoRecords', response.data)
                            resolve(true)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchVideoRecords4Date', args, inprogress: false})
                        /* getters.getTimeToday+24h and args.from/to intersect*/
                        if (isToday) {
                            dispatch('setLastCall', {name: 'fetchLastVideoRecords', args, inprogress: false})
                        }
                    });
            })
        },
        fetchVideoRecordsChanged({dispatch, getters}, args) {
            if (!getters.getApiToken) {
                return Promise.resolve(null)
            }

            dispatch('setLastCall', {name: 'fetchLastVideoRecords', args, time: Date.now() / 1000})
            dispatch('setLastCall', {name: 'fetchVideoRecordsChanged', args, time: Date.now() / 1000})

            // args = {...consts.querySettings.filter, ...args}
            // delete args.date
            args.force = true
            return dispatch('fetchVideoRecords4Date', args)
                .finally(() => {
                    dispatch('setLastCall', {name: 'fetchLastVideoRecords', args, inprogress: false})
                    dispatch('setLastCall', {name: 'fetchVideoRecordsChanged', args, inprogress: false})
                });
        },
        reloadVideoRecords({commit, dispatch}, args) {
            commit('clearVideoRecords')
            return dispatch('fetchVideoRecords4Date', {date: 'today', ...args})
        },

        //sayHello() {}
    },
    mutations: {
        setVideoRecordsIndex(state, params) {
            let i = state.videoRecords_index.findIndex(i => i.date == params.date && i.unitId == params.unitId)
            if (i < 0) {
                state.videoRecords_index.push(Object.freeze({...params}))
            } else {
                state.videoRecords_index[i] = Object.freeze({...state.videoRecords_index[i], ...params})
            }
        },
        storeVideoRecords(state, nRecords) {
            if (!state.videoRecords.length) {
                state.videoRecords = nRecords.map(r => Object.freeze(r))
                return true
            }

            const indexByXid = getVideoRecordsIndexMap(state)

            nRecords.forEach(function (nRecord) {
                let i = indexByXid.has(nRecord.xid) ? indexByXid.get(nRecord.xid) : -1
                if (i < 0) {
                    indexByXid.set(nRecord.xid, state.videoRecords.length)
                    state.videoRecords.push(Object.freeze(nRecord))
                } else {
                    // updateObjectByDiff(state.videoRecords[i], nRecord)
                    delete nRecord.xid
                    state.videoRecords[i] = Object.freeze({...state.videoRecords[i], ...nRecord})
                }
            })
        },
        clearVideoRecords(state, {unitId} = {}) {
            if (unitId) {
                state.videoRecords = state.videoRecords.filter(r => (r.unit_id || r.object_id) != unitId)
                state.videoRecords_index = state.videoRecords_index.filter(i => i.unitId != unitId)
            } else {
                state.videoRecords = [];
                state.videoRecords_index = [];
            }
        },
    },
    getters: {
        getVideoRecordsIndex(state) {
            return state.videoRecords_index
        },
        getVideoRecords(state) {
            return state.videoRecords
        },
        getVideoRecordsByIds(state) {
            return state.videoRecords.reduce((videoRecordsByIds, event) => {
                videoRecordsByIds[event.id] = event
                return videoRecordsByIds
            }, {})
        },
    }
}
